import ProfessionalThemeHeader from '@/components/common/Header/ProfessionalThemeHeader';
import CourseDescriptionContext from '@/context/CourseDescriptionContext';
import { companyImage } from '@/utils/common/env.constants';
import { Container, Slider, Typography } from '@pwskills/rachnaui';
import React, { useContext } from 'react';

const KeyCourseElements = () => {
  const { courseDetails } = useContext(CourseDescriptionContext);
  const { courseOffering } = courseDetails?.courseMetaDetails || {};

  if (!courseOffering?.length) return null;

  // to show 4 items in mobile ui
  const chunkedCourseOffering = [];
  for (let i = 0; i < courseOffering.length; i += 4) {
    chunkedCourseOffering.push(courseOffering.slice(i, i + 4));
  }

  return (
    <section id="course-offerings" data-title="Offerings" className="py-8 medium:py-14">
      <Container className="medium:!px-8 large:!px-20">
        <ProfessionalThemeHeader title="Unlock Your Potential: Exclusive Course Offerings" />

        <div className="block medium:!hidden">
          <Slider positionOfSliderInMobile="bottom">
            {chunkedCourseOffering.map((chunk) => (
              <div className="mt-5 relative !w-[100%] large:!mx-6 rounded-b-[20px] rounded-t-[20px]  !shrink-0 flex flex-col  bg-white gap-6 ">
                {chunk.map(({ icon, name }) => (
                  <div
                    className="w-[95%] bg-white p-3 flex flex-row items-center gap-2 rounded border border-[#EFEFEF]"
                    key={name}
                  >
                    <img
                      src={`${companyImage}/course_offering_icons/${icon?.link}`}
                      alt="courseOfferings"
                      width="40"
                      height="40"
                      loading="lazy"
                    />
                    <Typography
                      component="body-small"
                      variant="semi-bold"
                      className="text-gray-850"
                    >
                      {name}
                    </Typography>
                  </div>
                ))}
              </div>
            ))}
          </Slider>
        </div>

        <div className=" overflow-scroll scrollbar-hide ">
          <div className=" medium:grid-cols-2 medium:grid-rows-auto large:grid-cols-4 gap-6 pt-6 items-center hidden medium:!grid">
            {courseOffering?.map(({ icon, name }) => (
              <div
                className="flex items-center justify-start p-3 border border-stroke-200 rounded-lg gap-x-2 w-[302px] "
                key={name}
              >
                <figure>
                  <img
                    src={`${companyImage}/course_offering_icons/${icon?.link}`}
                    alt="courseOfferings"
                    width="40"
                    height="40"
                    loading="lazy"
                  />
                </figure>
                <Typography component="body-small" variant="semi-bold" className="text-gray-850">
                  {name}
                </Typography>
              </div>
            ))}
          </div>
        </div>
      </Container>
    </section>
  );
};

export default KeyCourseElements;
